 
 
 

import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../hooks";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { useNavigate, useOutletContext } from "react-router-dom";
import styled from "@emotion/styled";
import { alpha, Button, Menu, MenuItem, MenuProps, Stack } from "@mui/material";
import { PageTitleBar } from "../../../../../components/PageTitleBar/PageTitleBar";
import { useDataTableV2Pagination } from "../../../../../components/TableV2/hooks/useDataTableV2Pagination";
import { useTableV2State } from "../../../../../components/TableV2/hooks/useTableV2State";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DataTableV2 } from "../../../../../components/TableV2/DataTableV2";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { formatText } from "../../../../../helpers";
import { StatusRenderer } from "../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { ControlledCustomSelect } from "../../../../../components/formsComponents";
import { StandardTableActions } from "../../../../../components/StandardTableActions/StandardTableActions";
import {
  downloadCommAutomobileAlbertaPDFApplications,
  downloadCommAutomobilePDFApplications,
  downloadCommAutomobileSupplementaryFormPDFAsync,
  fetchCommAutoAllApplicationsListAsync,
  previewCommAutomobileAlbertaPDFApplications,
  previewCommAutomobilePDFApplications,
  previewCommAutomobileSupplementaryFormPDFAsync,
} from "../../../../../redux/commAutoPolicy/commAutoAllApplications/commAutoAllApplicationsActions";
import {
  ICommAutoApplicationList,
  ICommAutomobileQuickAplication,
  INITIAL_QUICK_APPLICATION,
} from "../../../../../redux/commAutoPolicy/commAutoAllApplications/commAutoAllApplications.types";
import { RequestQuote } from "@mui/icons-material";
import { QuickApplicationDialog } from "./CommAutoApplication/QuickApplication";
import {
  downloadCommAutomobileCVSPDF,
  previewCommAutomobileCVSPDF,
} from "../../../../../redux/commAutoPolicy/commAutoSupplement/commAutoSupplementActions";
import { PageContainer } from "../../../../../components/container/PageContainer";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }: any) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const APPLICATION_TYPES = [
  { label: "All Applications", value: "all_application" },
  { label: "Automobile (AB)", value: "automobile_ab" },
  { label: "Automobile (ON)", value: "automobile_on" },
  { label: "Garage (ON)", value: "garage_on" },
  // { label: "Garage Supplement", value: "garage_supplementary" },
  // {
  //   label: "Commercial Vehicle Supplement",
  //   value: "commercial_vehicle_supplement",
  // },
  // { label: "Automobile (AB)", value: "automobile_ab" },
  // { label: "Garage (AB)", value: "garage_ab" },
];

const DOWNLOAD_FOR = [
  "automobile_ab",
  "automobile_on",
  "garage_on",
  "garage_supplementary",
  "commercial_vehicle_supplement",
];

const PREVIEW_FOR = [
  "automobile_ab",
  "automobile_on",
  "garage_on",
  "garage_supplementary",
  "commercial_vehicle_supplement",
];

export const CommAutoApplicationRoot = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  // const { addBreadcrumb } = useBreadcrumbContext();
  // const { getParm } = useQueryParms();
  // const tabValue = getParm("tab");
  // const selectedTab = tabValue ? Number(tabValue) : 0;
  const [downloading, setDownloading] = React.useState(false);
  const [openView, setOpenView] =
    React.useState<ICommAutomobileQuickAplication | null>(null);
  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.commAuto.allApplications.applicationsList
  );

  const { customerInfo } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );

  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const { tablePagination, onPageChange, onRowsPerPageChange } =
    useDataTableV2Pagination({
      pageNumber: 1,
      rowsInPerPage: 25,
      extraFetchFactor: 1,
    });
  const [policyFormRoot, setPolicyFormRoot] = React.useState("all_application");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFormTypeClick = (value: string, incrementNumber?: any) => () => {
    setAnchorEl(null);
    let additionalparms = "";
    if (incrementNumber) {
      additionalparms = "/" + incrementNumber;
    }
    switch (value) {
         case "automobile_ab": {
        navigate(
          `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/alberta-application${additionalparms}`
        );
        return;
      }
      case "automobile_on": {
        navigate(
          `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/application${additionalparms}`
        );
        return;
      }
      case "garage_on": {
        navigate(
          `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/garage${additionalparms}`
        );
        return;
      }
      case "garage_supplementary": {
        navigate(
          `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/garage-supplement${additionalparms}`
        );
        return;
      }
      case "commercial_vehicle_supplement": {
        navigate(
          `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/csv-detail-information${additionalparms}`
        );
        return;
      }
    }
  };

  const handleDownload = (
    application_type: string,
    incemental_number: number
  ) => {
    switch (application_type) {
      case "automobile_ab": {
        dispatch(
          downloadCommAutomobileAlbertaPDFApplications(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "automobile_on": {
        dispatch(
          downloadCommAutomobilePDFApplications(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "garage_supplementary": {
        dispatch(
          downloadCommAutomobileSupplementaryFormPDFAsync(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "commercial_vehicle_supplement": {
        dispatch(
          downloadCommAutomobileCVSPDF(customerPolicyId, incemental_number)
        );
        return;
      }
    }
  };

  const handlePreview = (
    application_type: string,
    incemental_number: number
  ) => {
    switch (application_type) {
      case "automobile_ab": {
        dispatch(
          previewCommAutomobileAlbertaPDFApplications(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "automobile_on": {
        dispatch(
          previewCommAutomobilePDFApplications(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "garage_supplementary": {
        dispatch(
          previewCommAutomobileSupplementaryFormPDFAsync(
            customerPolicyId,
            incemental_number
          )
        );
        return;
      }
      case "commercial_vehicle_supplement": {
        dispatch(
          previewCommAutomobileCVSPDF(customerPolicyId, incemental_number)
        );
        return;
      }
    }
  };

  const {
    state: { dateState, searchState, tabs, columnsConfig,
      dense },
    setDateState,
    setSearchState,
    setSelectedTab,
    setColumnVisibility,
 
    onDenseToggle, } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last90Days",
      selectedTab: "-1",
    },
  });

  const fetchList = () => {
    dispatch(
      fetchCommAutoAllApplicationsListAsync(
        customerPolicyId,
        policyFormRoot,
        tablePagination.pageNumber,
        tablePagination.rowsInPerPage
      )
    );
  };

  const handleARSOpen = () => {
    navigate(
      `/comm-automobile-policy/${customerId}/application-tab/${customerPolicyId}/quote-ars`
    );
  };

  const handlequickApplication = () => {
    fetchList();
    setOpenView(null);
  };

  const AutomobileApplicationDataProps: IDataTableV2Props = {
    isPagination: true,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    extraFetchFactor: tablePagination.extraFetchFactor,
    isDataLoading: loading === LoadState.InProgress,
    selectionMode: "none",
    uniqueRowKeyName: "incemental_number",
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <ControlledCustomSelect
                sx={{ minWidth: "120px" }}
                value={policyFormRoot}
                options={APPLICATION_TYPES}
                onChange={(e) => setPolicyFormRoot(e.target.value as string)}
              ></ControlledCustomSelect>
            ),
          },
        ],
      },
      rightItems: {
        customPlugins: [],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICommAutoApplicationList) => {
          return (
            <StandardTableActions
              onEditClick={handleFormTypeClick(
                row.application_type,
                row.incremental_number
              )}
              onDownLoadClick={
                DOWNLOAD_FOR.includes(row.application_type)
                  ? () =>
                      handleDownload(
                        row.application_type,
                        row.incremental_number
                      )
                  : undefined
              }
              onDownloadPreview={
                PREVIEW_FOR.includes(row.application_type)
                  ? () =>
                      handlePreview(
                        row.application_type,
                        row.incremental_number
                      )
                  : undefined
              }
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICommAutoApplicationList) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
      },

      {
        key: "application_type",
        headerName: "Application Type",
        fieldName: "application_type",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 30,
        onRowCellValueRender: (value, row) => {
          return formatText(value).toUpperCase();
        },
      },
      {
        key: "create_ts",
        headerName: "Date Created",
        fieldName: "create_ts",
        renderType: DataTableV2RowRenderType.DATE,
        // exportCellWidth: 30,
      },
      {
        key: "created_by_name",
        headerName: "Created By",
        fieldName: "created_by_name",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 30,
      },
    ],
    initialSortConfig: {
      insert_ts: {
        direction: "desc",
        filedName: "create_ts",
      },
    },
    rows: list,
    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange,
      dense: dense,
    onDenseToggle: onDenseToggle,};

  React.useEffect(() => {
    if (customerPolicyId) {
      fetchList();
    }
  }, [customerPolicyId]);

  return (
    <PageContainer title={"Applications"} description={"Applications"}>
      <PageLoader
        loading={customerInfo.loading === LoadState.InProgress}
        error={customerInfo.error ? { message: customerInfo.error } : null}
      >
        <PageTitleBar
          heading="Commercial Automobile Applications"
          rightHeading={
            <Stack direction={"row"} spacing={1}>
              <Button
                variant="contained"
                onClick={() => {
                  setOpenView({
                    ...INITIAL_QUICK_APPLICATION,
                  });
                }}
              >
                Quick Create
              </Button>
              <Button
                variant="contained"
                disableElevation
                onClick={handleARSOpen}
                endIcon={<RequestQuote />}
              >
                Create From ARS Quote
              </Button>
              <Button
                id="demo-customized-button"
                aria-controls={open ? "demo-customized-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Create
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
              >
                {APPLICATION_TYPES.slice(1).map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      onClick={handleFormTypeClick(item.value)}
                      disableRipple
                    >
                      {item.label}
                    </MenuItem>
                  );
                })}
              </StyledMenu>
            </Stack>
          }
        />

        <DataTableV2 {...AutomobileApplicationDataProps} />
        {/* <TabsList
        sx={{ mb: 1 }}
        varaint="scrollable"
        selectedTab={selectedTab}
        tabs={[
          {
            label: "Automobile (AB)",
            icon: <AdminPanelSettings />,
          },
          {
            label: "Automobile (ON)",
            icon: <AdminPanelSettings />,
          },
          {
            label: "Garage (AB)",
            icon: <AccountCircle />,
          },
          {
            label: "Garage (ON)",
            icon: <AccountCircle />,
          },
          {
            label: "Garage Supplement",
            icon: <AccountCircle />,
          },
          {
            label: "Commercial Vehicle Supplement",
            icon: <AccountCircle />,
          },
        ]}
        onChange={handleChange}
      />
      <TabPanel value={selectedTab} index={1}>
        <CommAutomobileApplicationList />
      </TabPanel>
      <TabPanel value={selectedTab} index={3}>
      <CommAutoInsuranceGarageApplicationList />
      </TabPanel>
      <TabPanel value={selectedTab} index={4}>
      <CommAutoSupplementaryFormList
      customerId={customerId}
      customerPolicyId={customerPolicyId}
      />
      </TabPanel>
      <TabPanel value={selectedTab} index={5}>
      <CommAutomobileCSVList />
      </TabPanel> */}

        {openView && (
          <QuickApplicationDialog
            open={true}
            customerPolicyId={customerPolicyId}
            customerId={customerId}
            type={"commauto"}
            data={openView}
            onClose={() => setOpenView(null)}
            onComplete={handlequickApplication}
          />
        )}
      </PageLoader>
    </PageContainer>
  );
};
